import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { BottomModalBase, NotePersonDetails, NotePersonLine } from '@components'
import { useNotePerson } from '../hooks'

interface NotePersonCompactProps {
  contactId: string
  // The note being written, left out of « N autres notes ».
  currentNoteId?: string
  // « 28 sept. 2026 », or null while the note is not saved yet.
  writtenOn: string | null
  canChange: boolean
  onOpenProfile: () => void
  onOpenNotes: () => void
  onChangePerson: () => void
}

// The person of a note on the phone: one line under the text, so that a long
// note keeps the screen, and their details in a sheet opened by a tap.
export const NotePersonCompact = ({
  contactId,
  currentNoteId,
  writtenOn,
  canChange,
  onOpenProfile,
  onOpenNotes,
  onChangePerson,
}: NotePersonCompactProps) => {
  const person = useNotePerson(contactId, currentNoteId)
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)
  const insets = useSafeAreaInsets()

  // Every action of the sheet closes it first.
  const closeThen = (action: () => void) => () => {
    setIsDetailsOpen(false)
    action()
  }

  return (
    <>
      <NotePersonLine
        name={person.name}
        avatarUrl={person.avatarUrl}
        lastExchange={person.lastExchange}
        onPress={() => setIsDetailsOpen(true)}
      />
      <BottomModalBase
        isVisible={isDetailsOpen}
        setIsVisible={setIsDetailsOpen}
        largePaddingTop={false}
        wrapContent
      >
        {/* The sheet goes down to the edge of the screen: its buttons stay
            above the iPhone's home bar. */}
        <View style={[styles.details, { paddingBottom: insets.bottom }]}>
          <NotePersonDetails
            name={person.name}
            avatarUrl={person.avatarUrl}
            hashtags={person.hashtags}
            lastExchange={person.lastExchange}
            otherNotesCount={person.otherNotesCount}
            writtenOn={writtenOn}
            onOpenProfile={closeThen(onOpenProfile)}
            onOpenNotes={closeThen(onOpenNotes)}
            onChange={canChange ? closeThen(onChangePerson) : undefined}
          />
        </View>
      </BottomModalBase>
    </>
  )
}

const styles = StyleSheet.create({
  details: {
    width: '100%',
  },
})
